import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { InfoTab } from './components/main/InfoTab';
import { CommonModal } from './components/modal/CommonModal';
import { useApiHook } from './hook/useApiHook';
import { EndDateModal } from './components/modal/EndDateModal';
import { closeWebview, isWeb, mobileQuery } from './utils';
import { MAIN_TAB_STATUS, SUB_TAB_STATUS } from './types/type';
import { RewardInfo } from './components/main/reward/RewardInfo';
import { TestBox } from './components/TestBox';
import { Header } from './components/main/Header';
import { ProgressInfo } from './components/main/progress/ProgressInfo';
import { MainEvent } from './components/main/main-event/MainEvent';
import { ParticipationInfo } from './components/main/participate/ParticipationInfo';
import { ImageUtils } from './utils/ImageUtils';
import { Flare } from './components/main/Flare';
import { infoStore, ParticipationStatus } from './store/infoStore';
import { MODAL_TYPE, modalStore } from './store/modalStore';
import { useDateHook } from './hook/useDateHook';

export const App = () => {
  const { info } = infoStore();
  const { showModal } = modalStore();
  const [mainTab, setMainTab] = useState<MAIN_TAB_STATUS>(MAIN_TAB_STATUS.REWARD);
  const [subTab, setSubTab] = useState<SUB_TAB_STATUS>(SUB_TAB_STATUS.ONLINE);
  const { getEventInfo } = useApiHook();
  const isMobile = !isWeb();
  const { isOpenTabDate } = useDateHook();

  useEffect(() => {
    if (isMobile) getEventInfo();
  }, [getEventInfo, isMobile]);

  // 참가권 획득 유저이고 새틀라이트 탭이 열린 시간이면 새틀라이트 탭을 디폴트로 설정
  useEffect(() => {
    if (!isOpenTabDate) {
      return;
    }

    if (isMobile && info.status === ParticipationStatus.CHECK_ELIGIBLE) {
      setMainTab(MAIN_TAB_STATUS.PROGRESS);
    }
  }, [info.status]);

  const goMainEventTab = () => {
    if (info.status === ParticipationStatus.NO_TICKETS) {
      showModal({ modalType: MODAL_TYPE.CHECK_TICKET });
      return;
    }

    setMainTab(MAIN_TAB_STATUS.MAIN_EVENT);
  };

  const goOfflineTab = () => {
    setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
    setTimeout(() => {
      setSubTab(SUB_TAB_STATUS.OFFLINE);
    }, 0);
  };

  const goOnlineTab = () => {
    setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
    setSubTab(SUB_TAB_STATUS.ONLINE);
  };

  return (
    <Wrap>
      <Bg />
      <TestBox />
      <Flare />
      {isMobile && <CloseButton src={ImageUtils.CloseIcon} onClick={closeWebview} />}
      <HeaderContainer>
        <Header />
        <InfoTab mainTab={mainTab} setMainTab={setMainTab} setSubTab={setSubTab} />
      </HeaderContainer>
      <BottomContainer>
        <Inner>
          {mainTab === MAIN_TAB_STATUS.REWARD && <RewardInfo />}
          {mainTab === MAIN_TAB_STATUS.PARTICIPATE && (
            <ParticipationInfo subTab={subTab} setSubTab={setSubTab} />
          )}
          {mainTab === MAIN_TAB_STATUS.PROGRESS && (
            <ProgressInfo
              goMainEventTab={goMainEventTab}
              goOfflineTab={goOfflineTab}
              goOnlineTab={goOnlineTab}
            />
          )}
          {mainTab === MAIN_TAB_STATUS.MAIN_EVENT && <MainEvent goOfflineTab={goOfflineTab} />}
        </Inner>
      </BottomContainer>
      <CommonModal />
      <EndDateModal />
    </Wrap>
  );
};

const Wrap = styled.div`
  width: 100%;
  position: relative;
  z-index: 2;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const HeaderContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 1076px;
  margin: 0 auto;
`;

const CloseButton = styled.img`
  width: 32px;
  height: 32px;
  position: absolute;
  right: 24px;
  top: 24px;
  z-index: 1;

  ${mobileQuery} {
    width: 16px;
    height: 16px;
    right: 12px;
    top: 12px;
  }
`;

const BottomContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1;
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1074px;
  margin: 0 auto;
  background: #302e2d;
`;

const Bg = styled.div`
  position: fixed;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
  background: linear-gradient(164deg, #0076da 4.5%, #0043a8 24.9%, #120b38 62.84%, #070526 100.33%);
  z-index: 0;
`;
